import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore } from "@/stores";
import OrderDemand from "@/models/frontend/OrderDemand.ts";

export const useOrderDemandStore = defineStore("orderDemand", {
  state: () => ({
    error: "" as any,
    data: [] as OrderDemand[],
  }),
  actions: {
    async fetchAll(siteId: number | undefined = undefined) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      this.error = "";
      let url = "v1.0/order-demand";
      if (siteId) {
        url = "v1.0/order-demand?siteId=" + siteId
      }
      await api
        .get<OrderDemand[]>(url)
        .then((response) => this.data = response.data)
        .catch((error) => (this.error = error));
    },
  },
});
